import { getSelectNodeAfterFilter } from 'app/utils/helpers';
import { Component, Injector, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CellClickedEvent, CellDoubleClickedEvent, GridOptions, GridReadyEvent } from 'ag-grid';
import { CellClassParams } from 'ag-grid/dist/lib/entities/colDef';
import { AgGridSortFilterUtils } from 'app/core/ag-grid-utils/ag-grid-sort-filter-utils';
import {
  AgButtonsEnum,
  DepositAction,
  DepositActions,
  DepositGridName,
  DepositsStatusEnum,
  TabsDepositsEnum
} from 'app/core/enums/tabs-deposits.enum';
import { FormatCurrencyHelper } from 'app/core/helpers/format-currency-helper';
import { CustomDate } from 'app/core/helpers/format-date-helper';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { IDeposit, IPosted } from 'app/core/interfaces/deposit.interface';
import { ConciliationService } from 'app/core/services/conciliation.service';
import { ParentModule } from 'app/pages/A2-utils/ParentClass/parent-module';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { Observable, Subscription } from 'rxjs';
import { BtnCellRendererComponent } from 'app/pages/A2-utils/grid-components/btn-cell-renderer/btn-cell-renderer.component';
import { BtnCellRendererI } from 'app/core/interfaces/Btn-cell-renderer.interface';
import { T2CardComponent } from 'app/trip2-theme/components/t2-card/t2-card.component';
import { constant } from 'app/app.constants';

@Component({
  selector: 'app-conciliation',
  templateUrl: './conciliation.component.html',
  styleUrls: ['./conciliation.component.scss']
})
export class ConciliationComponent extends ParentModule implements OnInit, OnDestroy {
  @ViewChild('modalPosted') modalPosted: T2CardComponent;
  gridPostedWithoutDeposit: GridOptions;
  gridDepositOptions: GridOptions;
  conciliationSearch: FormGroup;
  postedCrudForm: FormGroup;
  selectedRowIndex = null;
  postedItemSelected: any[] = [];
  deopositItemSelected: any [] = [];
  subscriptions: Subscription[] = [];
  statusSelectedList = [];
  dropdownSettings = {};
  depositStatusList = [];
  public actionsConciliation = [];
  totalRows = 0;
  totalDepositAmountSelected = 0;
  totalPostedAmountSelected = 0;
  postedeGridRowsCounts = 0;
  agGridButtonActionList = {
    RemoveFilter: AgButtonsEnum.RemoveFilter,
    RemoveSort: AgButtonsEnum.RemoveSort
  };
  gridListName = {
    DepositGrid: DepositGridName.DepositGrid,
    PostedGridRight: DepositGridName.PostedGridRight
  };

  enableClearFilter = true;
  enableClearSort = true;
  enableClearFilterPostedGrid = true;
  enableClearSortPostedGrid = true;
  totalCredit = 0;
  totalPostedAmount = 0;
  filteredDataAndSort: any[] = [];
  indexCountStepper = 0;
  zeroBalanceCheckBox = false;
  noBlankSpace = constant.NO_BLANK_SPACE;

  get idConciliationCtrl(): AbstractControl {
    return this.conciliationSearch.get('id');
  }

  get descriptionConciliationCtrl(): AbstractControl {
    return this.conciliationSearch.get('description');
  }

  get depositMonthConciliationCtrl(): AbstractControl {
    return this.conciliationSearch.get('depositdateconciliation');
  }

  get hasSelectedRow(): boolean {
    if (this.gridDepositOptions && this.gridDepositOptions.api &&
      this.postedItemSelected && this.postedItemSelected.length
    ) {
      return this.gridDepositOptions.api!.getSelectedNodes().map(row => row.data).find(() => true);
    } else {
      return false;
    }
  }

  get postedId(): number {
    return this.postedCrudForm.get('id').value;
  }

  get validControls(): boolean {
    return this.postedCrudForm.valid;
  }

  constructor(
    private sweetAlertHelper: SweetAlertHelper,
    private t2LoadingService: T2LoadingService,
    protected objServ: ConciliationService,
    private fb: FormBuilder,
    private objToast: ToastrAlertHelper,
    protected inject: Injector
  ) {
    super('app-deposits', inject);
    this.createForm();
    this.gridBuilder();
  }

  ngOnInit(): void {
    this.initSubscriptions();
    this.settingDropDown();
    this.getDepositStatus();
    this.getDepositbyCurrentMonth();
  }

  initSubscriptions(): void {
    this.subscriptions.push(
      this.$actions.subscribe({
        next: (actions) => {
          if (actions && actions.length) {
            this.actionsConciliation = actions;
          }
        },
        error: (er) => this.sweetAlertHelper.captureException(er)
      }),
      this.objServ.behaviorSubjDepositObs$.subscribe({
        next: (res) => {
          if (res && res.action === DepositAction.SearchConciliation && res.data) {
            this.filteredDataAndSort = [];
            this.indexCountStepper = 0;

            const dateMonthLockBox = this.depositMonthConciliationCtrl.value;
            const req: IPosted = {
              depositdate: CustomDate.formatJs(dateMonthLockBox, 'MM-yyyy'),
              includeZeroBalance: this.zeroBalanceCheckBox,
              id: this.idConciliationCtrl.value,
              description: this.descriptionConciliationCtrl.value,
              depositstatusids: this.statusSelectedList.map(el => el.id)
            };
            this.searchDeposit(req);
            this.getPostedWithoutDeposit(req);
            if (this.gridDepositOptions && this.gridDepositOptions.columnApi) {
              const postedDeleteAction = this.actionsConciliation.includes(DepositActions.PostedDelete);
              this.gridDepositOptions.columnApi.setColumnVisible('action', postedDeleteAction);
            }
          }
        },
        error: (er) => this.sweetAlertHelper.captureException(er)
      }),
      this.objServ.behaviorSubjDeposit.subscribe({
        next: (res) => {
          if (res && res.data &&
            (
              res.action === DepositAction.MonthPickerSetterValueChangesDeposit ||
              res.action === DepositAction.MonthPickerSetterValueChangesLockBoxResp ||
              res.action === DepositAction.MonthPickerSetterValueChangesPostedResp ||
              res.action ===  DepositAction.MonthPickerSetterValueChangesElectronicResp
            )
          ) {
            this.depositMonthConciliationCtrl.patchValue(res.data, { emitEvent: false });
          }
        },
        error: (er) => this.sweetAlertHelper.captureException(er)
      }),
      this.conciliationSearch.get('depositdateconciliation')
      .valueChanges.subscribe({
        next: (res) => {
          if (res) {
            this.objServ.behaviorSubjDeposit.next({
              action: DepositAction.MonthPickerSetterValueChangesConciliationResp,
              data: res
            });
          }
        },
        error: (er) => this.sweetAlertHelper.captureException(er)
      })
    );
  }

  createForm(): void {
    this.conciliationSearch = this.fb.group({
      depositdateconciliation: null,
      id: null,
      description: null
    });
    this.postedCrudForm = this.fb.group({
      id: null,
      payor: [null, Validators.required],
      amtpaid: [null, [Validators.required, Validators.pattern(this.noBlankSpace)]],
      posteddate: [null, Validators.required],
      checkdate: [null, Validators.required],
      checknumber: [null, [Validators.required, Validators.pattern(this.noBlankSpace)]],
      depositdate: [null, Validators.required],
      rcsql: [null, [Validators.required, Validators.pattern(this.noBlankSpace)]],
      company: [null, [Validators.required, Validators.pattern(this.noBlankSpace)]],
      depositid: null
    });
  }

  gridBuilder(): void {
    this.gridDepositOptions = <GridOptions> {
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      suppressRowClickSelection: true,
      rowSelection: 'single',
      frameworkComponents: {
        buttonRenderer: BtnCellRendererComponent
      },
      columnDefs: [
        {
          headerName: 'Sel.',
          colId: 'depositidselected',
          checkboxSelection: true,
          headerCheckboxSelection: false,
          width: 30
        },
        {
          headerName: 'ID',
          field: 'id',
          width: 60,
          cellStyle: { 'text-align': 'end' }
        },
        {
          headerName: 'Account Number',
          field: 'accountnumber',
          width: 130,
          cellStyle: { 'text-align': 'start' },
        },
        {
          headerName: 'Deposit Date',
          field: 'depositdate',
          width: 100,
          valueGetter: (params) => {
            if (params && params.data.depositdate) {
              return CustomDate.formatJs(params.data.depositdate);
            }
          },
          cellStyle: { 'text-align': 'center' }
        },
        {
          headerName: 'Description',
          field: 'description',
          cellStyle: { 'text-align': 'start' },
          width: 130
        },
        {
          headerName: 'Deposit id',
          field: 'depositstatusid',
          width: 5,
          hide: true
        },
        {
          headerName: 'Deposit Status',
          field: 'depositstatusdescription',
          width: 100,
          cellStyle: params => {
            const cellStyleObj = { 'text-align': 'start', color: 'black', 'font-weight' : 'normal' };
            if (params && params.data.depositstatusid) {
              switch (params.data.depositstatusid) {
                case DepositsStatusEnum.Pending:
                  cellStyleObj.color = 'red';
                  cellStyleObj['font-weight'] = 'bold';
                  break;
                case DepositsStatusEnum.Completed:
                  cellStyleObj.color = 'green';
                  cellStyleObj['font-weight'] = 'bold';
                  break;
                default:
                  break;
              }
            }
            return cellStyleObj;
          }
        },
        {
          headerName: 'Imported On',
          field: 'importedon',
          width: 40,
          hide: true,
          valueGetter: (params) => {
            if (params && params.data && params.data.importedon) {
              return CustomDate.formatJs(params.data.importedon);
            }
          },
          cellRenderer: (params) => {
            let ico = '';
            let wasImported = null;

            if (params && params.data && params.data.importedon) {
              ico = 'fa icofont-check color-success';
              wasImported = 'Imported';
            }

            return wasImported &&
            `<center>${params.data.importedon}
            <i class="${ico}" aria-hidden="true" style='font-size: 20px' title="${wasImported}"></i></center>`;
          }
        },
        {
          headerName: '#',
          field: 'depositdetailcount',
          cellStyle: { 'text-align': 'end' },
          width: 40
        },
        {
          headerName: 'Credit',
          field: 'credit',
          cellStyle: { 'text-align': 'end' },
          width: 110,
          cellRenderer: (params) => {
            const decimal = 0;
            return params && params.data.credit
              ? '$' + params.data.credit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
              : '$' + decimal.toFixed(2);
          },
          filterParams: AgGridSortFilterUtils.sortFilterColumn
        },
        {
          headerName: 'Posted Amt',
          field: 'totalpostedamt',
          cellStyle: { 'text-align': 'end' },
          width: 110,
          cellRenderer: (params) => {
            const decimal = 0;
            return params && params.data.totalpostedamt
            ? '$' + params.data.totalpostedamt.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            : '$' + decimal.toFixed(2);
          },
          filterParams: AgGridSortFilterUtils.sortFilterColumn
        },
        {
          headerName: 'Adj Amt',
          field: 'depositdetailadjustment',
          cellStyle: { 'text-align': 'end' },
          width: 110,
          cellRenderer: (params) => {
            const decimal = 0;
            return params && params.data.depositdetailadjustment
              ? '$' + params.data.depositdetailadjustment.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
              : '$' + decimal.toFixed(2);
          },
          filterParams: AgGridSortFilterUtils.sortFilterColumn
        },
        {
          headerName: 'Diff',
          field: 'diff',
          cellStyle: { 'text-align': 'end' },
          width: 110,
          cellRenderer: (params) => {
            const decimal = 0;
            return params && params.data.diff
            ? '$' + params.data.diff.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            : '$' + decimal.toFixed(2);
          },
          filterParams: AgGridSortFilterUtils.sortFilterColumn
        },
        {
          headerName: 'Actions',
          field: '',
          colId: 'action',
          cellRenderer: 'buttonRenderer',
          cellStyle: {
            color: 'red',
            'font-size': '15px',
            'text-align': 'center'
          },
          width: 40,
          hide: false,
          cellRendererParams: (params: any) => {
            if (params && params.data.id) {
              const OBJ_RETURN: BtnCellRendererI = {
                onClick: () => this.deleteRow(params, DepositGridName.DepositGrid),
                classFontAwesome: 'fa-trash',
                bgColor: '#fff',
                color: '#ee0000',
                title: `Delete Deposit #${params.data.id}`,
                border: '1px solid #ddd',
              };

              return OBJ_RETURN;
            } else {
              return {
                onClick: null,
                classFontAwesome: '',
                title: ``,
                showBtn: false,
              };
            }
          }
        },
        {
          headerName: 'Note',
          field: 'note',
          width: 100,
          hide: true
        }
      ],
      onGridReady: (event: GridReadyEvent) => {
        if (event && this.gridDepositOptions.api) {
          this.gridDepositOptions.api.setRowData([]);
        }
      },
      onCellClicked: (event: CellClickedEvent) => {
        if (event && event.api) {
          event.api.clearFocusedCell();
        }
      },
      onRowClicked: (event) => {
        if (event && event.data && event.data.id) {
          this.selectedRowIndex = event.data.id;
          this.onselectionRowClick(event.data);
        }
        this.gridDepositOptions.api.redrawRows();
      },
      onCellDoubleClicked: (params: CellDoubleClickedEvent) => {
        if (params && params.data && params.data.id) {
          this.t2LoadingService.show();
          this.subscriptions.push(
            this.getDepositDetailWithoutSubs(params.data.id)
            .subscribe({
              next: (resp) => {
                if (params.data.id) {
                  this.onChangeTabs(params.data, resp);
                }
              },
              error: (er) => {
                this.sweetAlertHelper.captureException(er);
              }
            })
          );
        }
      },
      onFilterChanged: () => {
        this.selectedRowIndex = null;
        this.deselectAll(DepositGridName.DepositGrid);
        this.updateButtonState(DepositGridName.DepositGrid);
        this.gridDepositOptions.api.redrawRows();
      },
      onSortChanged: () => {
        this.deselectAll(DepositGridName.DepositGrid);
        this.updateButtonState(DepositGridName.DepositGrid);
      },
      onSelectionChanged: () => {
        this.onSelectionChanged();
      },
      rowClassRules: {
        'row-default-deposit-grid': (params) => {
          return params.data.id !== null;
        },
        'row-selected-deposit': (params) => {
          return params && params.data && params.data.id === this.selectedRowIndex;
        }
      },
      getRowNodeId: (data) => data.id
    };

    this.gridPostedWithoutDeposit = <GridOptions> {
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      suppressRowClickSelection: true,
      rowSelection: 'multiple',
      frameworkComponents: {
        buttonRenderer: BtnCellRendererComponent
      },
      columnDefs: [
        {
          headerName: 'Sel.',
          colId: 'postedidselected',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          width: 30
        },
        {
          headerName: 'Posted ID',
          field: 'id',
          cellStyle: { 'text-align': 'end' },
          width: 70,
          hide: true
        },
        {
          headerName: 'Deposit Date',
          field: 'depositdate',
          width: 120,
          valueGetter: (params) => {
            if (params && params.data.depositdate) {
              return CustomDate.formatJs(params.data.depositdate);
            }
          },
          cellStyle: { 'text-align': 'center' }
        },
        {
          headerName: 'Posted Date',
          field: 'posteddate',
          width: 110,
          valueGetter: (params) => {
            if (params && params.data.posteddate) {
              return CustomDate.formatJs(params.data.posteddate);
            }
          },
          cellStyle: { 'text-align': 'center' },
          hide: true
        },
        {
          headerName: 'Check Date',
          field: 'checkdate',
          width: 120,
          valueGetter: (params) => {
            if (params && params.data.checkdate) {
              return CustomDate.formatJs(params.data.checkdate);
            }
          },
          cellStyle: { 'text-align': 'center' }
        },
        {
          headerName: 'Check Number',
          field: 'checknbr',
          width: 180
        },
        {
          headerName: 'Posted Amount',
          field: 'amount',
          width: 120,
          cellStyle: { 'text-align': 'end' },
          cellRenderer: (params) => {
            const decimal = 0;
            return params && params.data && params.data.amount
            ? '$' + params.data.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            : '$' + decimal.toFixed(2);
          },
          filterParams: AgGridSortFilterUtils.sortFilterColumn
        },
        {
          headerName: 'Payor',
          field: 'payor',
          width: 200
        },
        {
          headerName: 'User',
          field: 'rcsql',
          width: 100
        },
        {
          headerName: 'Actions',
          field: '',
          colId: 'action',
          cellRenderer: 'buttonRenderer',
          cellStyle: {
            color: 'red',
            'font-size': '15px',
            'text-align': 'center'
          },
          width: 40,
          cellRendererParams: (params: any) => {
            if (params && params.data.id) {
              const OBJ_RETURN: BtnCellRendererI = {
                onClick: () => this.deleteRow(params, DepositGridName.PostedGridRight),
                classFontAwesome: 'fa-trash',
                bgColor: '#fff',
                color: '#ee0000',
                title: `Delete Deposit #${params.data.id}`,
                border: '1px solid #ddd',
              };

              return OBJ_RETURN;
            } else {
              return {
                onClick: null,
                classFontAwesome: '',
                title: ``,
                showBtn: false,
              };
            }
          }
        },
      ],
      onGridReady: (event: GridReadyEvent) => {
        if (event && this.gridPostedWithoutDeposit && this.gridPostedWithoutDeposit.api) {
          this.gridPostedWithoutDeposit.api.setRowData([]);
          this.gridPostedWithoutDeposit.api.sizeColumnsToFit();
        }
      },
      onRowClicked: (event) => {
        if (event && event.data) {
          this.selectedRowIndex = event.data.id;
        }
        this.gridPostedWithoutDeposit.api.redrawRows();
      },
      onCellDoubleClicked: (params: CellDoubleClickedEvent) => {
        if (params && params.data && params.data.id && this.actionsConciliation.includes(DepositActions.PostedEdit)) {
          this.modalPosted.open();
          this.setterData(params.data);
        }
      },
      onSelectionChanged: () => {
        this.onMultiSelectionChanged();
      },
      onFilterChanged: () => {
        this.selectedRowIndex = null;
        this.deselectAll(DepositGridName.PostedGridRight);
        this.modalPosted.close();
        this.updateButtonState(DepositGridName.PostedGridRight);
        this.gridPostedWithoutDeposit.api.redrawRows();
      },
      onSortChanged: () => {
        this.deselectAll(DepositGridName.PostedGridRight);
        this.modalPosted.close();
        this.updateButtonState(DepositGridName.PostedGridRight);
      },
      rowClassRules: {
        'row-default-deposit-grid': (params) => {
          return params.data.id !== null;
        },
        'row-selected-deposit': (params) => {
          return params && params.data && params.data.id === this.selectedRowIndex;
        }
      },
      getRowNodeId: (data) => data.id
    };
  }

  getDepositbyCurrentMonth(): void {
    this.conciliationSearch.get('depositdateconciliation')
    .patchValue(CustomDate.formatJsV2(CustomDate.getDate()), { emitEvent: false });
  }

  getRowStyleFn = (params: CellClassParams): any => {
    const confitStyle = {
      'cursor': 'pointer',
      'font-size': '17px',
      backgroundColor: '',
      'font-weight': ''
    };

    if (params && params.data && params.data.id === this.selectedRowIndex) {
      confitStyle.backgroundColor = '#b9e1ff';
      confitStyle['font-weight'] = 'bold';
      return confitStyle;
    }

    return confitStyle;
  }

  onMultiSelectionChanged(): void {
    this.postedItemSelected = getSelectNodeAfterFilter(this.gridPostedWithoutDeposit);
  }

  getTotalDepositGrid(objTable: string, dataSource: any[]): void {
    switch (objTable) {
      case DepositGridName.DepositGrid:
        if (dataSource && dataSource.length) {
          this.totalCredit = dataSource.reduce((sum, item) => sum + item.credit, 0);
          this.totalDepositAmountSelected = dataSource.reduce((sum, item) => sum + item.credit, 0);
        } else {
          this.totalCredit = 0;
          this.totalDepositAmountSelected = 0;
        }
        break;
      case DepositGridName.PostedGridRight:
        if (dataSource && dataSource.length) {
          this.totalPostedAmountSelected = dataSource.reduce((sum, item) => sum + item.amount, 0);
          this.totalPostedAmount = dataSource.reduce((sum, item) => sum + item.amount, 0);
        } else {
          this.totalPostedAmountSelected = 0;
          this.totalPostedAmount = 0;
        }
        break;
      default:
        break;
    }
  }

  onSelectionChanged(): void {
    const selectedData = this.gridDepositOptions.api!.getSelectedNodes().map(row => row.data).find(() => true);
    if (selectedData) {
      this.deopositItemSelected = [];
      this.deopositItemSelected.push(selectedData.id);
      this.selectedRowIndex = selectedData.id;
      this.indexCountStepper = (this.getCurrentIndex(selectedData.id) + 1);
    } else {
      this.indexCountStepper = 0;
      this.deopositItemSelected = [];
    }
  }

  onselectionRowClick(row: any): void {
    this.selectedRowIndex = row.id;
    this.indexCountStepper = (this.getCurrentIndex(row.id) + 1);
  }

  createDepositDetail(): void {
    if (this.hasSelectedRow) {
      this.t2LoadingService.show();
      const selectedNodes = this.gridDepositOptions.api!.getSelectedNodes();
      const selectedDepositRow = selectedNodes.map(row => row.data).find(() => true);

      this.postedItemSelected.map((row) => row.depositid = selectedDepositRow.id);

      this.subscriptions.push(
        this.objServ.createMassiveDepositDetails(this.postedItemSelected)
        .finally(() => {
          this.t2LoadingService.hiden();
          this.postedItemSelected = [];
          this.postedeGridRowsCounts = 0;
          this.gridPostedWithoutDeposit.api.setRowData([]);
        })
        .subscribe({
          next: (res) => {
            if (res && res.length) {
              if (selectedDepositRow && selectedDepositRow.id) {
                this.onChangeTabs(selectedDepositRow, res);
              }
              this.objToast.success('Successfully Saved', 'Attention', { positionClass: 'toast-bottom-right' });
            }
          },
          error: (er) => this.sweetAlertHelper.captureException(er)
        })
      );
    } else {
      this.totalPostedAmountSelected = 0;
      this.postedeGridRowsCounts = 0;
      this.postedItemSelected = [];
      this.gridPostedWithoutDeposit.api.setRowData([]);
      this.objToast.error('Deposit and Posted are required', 'Attention', { positionClass: 'toast-bottom-right' });
    }
  }

  intStyleCells(position: string): Object {
    return {
      'text-align': position,
      'border-right': '1px dotted rgba(20, 100, 246, 0.3)',
    };
  }

  setStyleCellsEmpty(position: string, borderColor: string): Object {
    return {
      'text-align': position,
      'border-left': '0.5px dotted ' + borderColor,
      'border-right': '0.5px dotted ' + borderColor,
      'border-top': '0.5px dotted ' + borderColor,
      'border-bottom': '0.5px dotted ' + borderColor,
      'background-colo': 'red'
    };
  }

  clearMonthDate(): void {
    this.depositMonthConciliationCtrl.patchValue('', { emitEvent: false });
  }

  run(): void {
    if (this.validRunAction()) {
      this.postedItemSelected = [];
      const idSearch = this.idConciliationCtrl.value;
      const id = !isNaN(idSearch) ? Number(idSearch) : null;
      const statusIds = this.statusSelectedList.map(row => row.id);
      const description = this.descriptionConciliationCtrl.value;
      const descVal = description ? description.trim() : null;

      const request: IDeposit = {
        id: id,
        depositstatusids: statusIds.length ? statusIds : [],
        description: descVal,
        depositdate: this.getDepositDateSetterRequest(),
        includeZeroBalance: this.zeroBalanceCheckBox
      };
      this.searchDeposit(request);
      if (request.depositdate) {
        this.getPostedWithoutDeposit(request);
      }
    } else {
      this.clearCountAndGrid();
      this.postedItemSelected = [];
      this.postedeGridRowsCounts = 0;
      this.totalPostedAmountSelected = 0;
      this.totalPostedAmount = 0;
      this.gridPostedWithoutDeposit.api.setRowData([]);
      this.filteredDataAndSort = [];
      this.indexCountStepper = 0;
      this.objToast.error('Action not allowed', '', { positionClass: 'toast-bottom-right' });
    }
  }

  validRunAction(): boolean {
    const idSearch = this.idConciliationCtrl.value;
    const id = !isNaN(idSearch) ? Number(idSearch) : null;
    const statusIds = this.statusSelectedList.map(row => row.id);
    const depositstatusids = statusIds.length ? statusIds : [];
    const description = this.descriptionConciliationCtrl.value;
    const descVal = description ? description.trim() : null;

    const depositdate = this.getDepositDateSetterRequest();

    return id || depositstatusids.length || descVal || depositdate;
  }

  getDepositObs(req: IDeposit): Observable<any> {
    return this.objServ.getDeposit(req);
  }

  searchDeposit(req: IDeposit): void {
    this.selectedRowIndex = null;
    let filterModel: any = null, fortModel: any = null;

    if (this.gridDepositOptions && this.gridDepositOptions.api) {
      filterModel = this.gridDepositOptions.api.getFilterModel();
      fortModel = this.gridDepositOptions.api.getSortModel();
    }
    this.t2LoadingService.show();
    this.subscriptions.push(
      this.getDepositObs(req)
      .finally(() => this.t2LoadingService.hiden())
      .subscribe({
        next: (resp) => {
          if (resp) {
            this.totalRows = resp.length;
            this.gridDepositOptions.api.setRowData(resp);
            this.getTotalDepositGrid(DepositGridName.DepositGrid, resp);
            if (filterModel) {
              this.gridDepositOptions.api.setFilterModel(filterModel);
            }
            if (fortModel) {
              this.gridDepositOptions.api.setSortModel(fortModel);
            }
            this.hideActionColumn();
          } else {
            this.clearCountAndGrid();
          }
        },
        error: (er) => {
          this.clearCountAndGrid();
          this.sweetAlertHelper.captureException(er);
        }
      })
    );
  }

  clearControl(controlName: string, value = null): void {
    this.conciliationSearch.get(controlName).patchValue(value);
  }

  clearSelectionStatus() {
    this.statusSelectedList = [];
  }

  settingDropDown(): void {
    this.dropdownSettings = {
      singleSelection: false,
      text: 'Select Status',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: '',
      badgeShowLimit: 1
    };
  }

  getDepositStatus(): void {
    this.t2LoadingService.show();
    this.subscriptions.push(
      this.objServ.getDepositStatus()
      .finally(() => this.t2LoadingService.hiden())
      .subscribe({
        next: (res) => {
          if (res) {
            this.initStatusList(res);
          }
        },
        error: (er) => this.sweetAlertHelper.captureException(er)
      })
    );
  }

  initStatusList(data: any[]): void {
    this.clearSelectionStatus();
    const mappedList = this.mapListStatus(data);
    this.setStatusList(mappedList);
  }

  mapListStatus(data: any[]): { id: number, itemName: string }[] {
    return data.length ? data.map((p: any) => ({ id: p.depositstatusid, itemName: p.description })) : [];
  }

  setStatusList(list: any[]): void {
    this.depositStatusList = list;
  }

  getDepositDetailWithoutSubs(depositId: number): Observable<any> {
    return this.objServ.getDetail(depositId).finally(() => this.t2LoadingService.hiden());
  }

  hideActionColumn(): void {
    if (this.gridDepositOptions && this.gridDepositOptions.columnApi) {
      const depositDeleteAction = this.actionsConciliation.includes(DepositActions.DepositDelete);
      this.gridDepositOptions.columnApi.setColumnVisible('action', depositDeleteAction);
    }
  }

  clearCountAndGrid(): void {
    this.totalDepositAmountSelected = 0;
    this.totalRows = 0;
    if (this.gridDepositOptions && this.gridDepositOptions.api) {
      this.gridDepositOptions.api.setRowData([]);
    }
  }

  formatCurrencyText(valueFormated): string {
    const formatVal = isNaN(Number(valueFormated)) ? 0 : Number(valueFormated);
    return FormatCurrencyHelper.formatCurrency(formatVal);
  }

  getPostedWithoutDeposit(req: IDeposit): void {
    let filterModel: any = null, fortModel: any = null;

    if (this.gridPostedWithoutDeposit && this.gridPostedWithoutDeposit.api) {
      filterModel = this.gridPostedWithoutDeposit.api.getFilterModel();
      fortModel = this.gridPostedWithoutDeposit.api.getSortModel();
    }
    this.t2LoadingService.show();
    this.subscriptions.push(
      this.objServ.getPostedWithoutDeposit(req)
      .finally(() => this.t2LoadingService.hiden())
      .subscribe({
        next: (resp) => {
          if (resp) {
            this.postedeGridRowsCounts = resp.length;
            this.gridPostedWithoutDeposit.api.setRowData(resp);
            this.getTotalDepositGrid(DepositGridName.PostedGridRight, resp);
            if (filterModel) {
              this.gridPostedWithoutDeposit.api.setFilterModel(filterModel);
            }
            if (fortModel) {
              this.gridPostedWithoutDeposit.api.setSortModel(fortModel);
            }
          } else {
            this.totalPostedAmountSelected = 0;
            this.gridPostedWithoutDeposit.api.setRowData([]);
          }
        },
        error: (er) => {
          this.totalPostedAmountSelected = 0;
          this.gridPostedWithoutDeposit.api.setRowData([]);
          this.sweetAlertHelper.captureException(er);
        }
      })
    );
  }

  getDepositDateSetterRequest(): string {
    const dateMonthLockBox = this.depositMonthConciliationCtrl.value;
    return CustomDate.formatJs(dateMonthLockBox, 'MM-yyyy');
  }

  onChangeTabs(deposit: any, detail: any): void {
    if (this.actionsConciliation.includes('DepositDetailTab')) {
      this.objServ.behaviorSubjDeposit.next({
        action: DepositAction.ChangeTabFromConciliation,
        data: {
          action: TabsDepositsEnum.Detail,
          deposit,
          detail,
          filteredDataAndSort: this.filteredDataAndSort,
          indexCountStepper: this.indexCountStepper
        }
      });
    }
  }

  clearFilterAndSort(nameBtn: AgButtonsEnum, gridName: string): void {
    switch (nameBtn) {
      case AgButtonsEnum.RemoveFilter:
        if (DepositGridName.DepositGrid === gridName) {
          this.gridDepositOptions.api.setFilterModel(null);
        } else if (DepositGridName.PostedGridRight === gridName) {
          this.gridPostedWithoutDeposit.api.setFilterModel(null);
        }
        break;
      case AgButtonsEnum.RemoveSort:
        if (DepositGridName.DepositGrid === gridName) {
          this.gridDepositOptions.api.setSortModel(null);
        } else if (DepositGridName.PostedGridRight === gridName) {
          this.gridPostedWithoutDeposit.api.setSortModel(null);
        }
        break;
      default:
        break;
    }
    this.updateButtonState(gridName);
  }

  updateButtonState(gridName: string): void {
    if (DepositGridName.DepositGrid === gridName) {
      const filterApply = !Object.keys(this.gridDepositOptions.api.getFilterModel()).length;
      this.enableClearFilter = filterApply;
      this.enableClearSort = !this.gridDepositOptions.api.getSortModel().length;

      if (!filterApply) {
        this.sumTotalDepositOrPostedSelected(gridName);
      } else {
        this.totalDepositAmountSelected = this.totalCredit;
      }
    } else if (DepositGridName.PostedGridRight === gridName) {
      const filterApplyPosted = !Object.keys(this.gridPostedWithoutDeposit.api.getFilterModel()).length;
      this.enableClearFilterPostedGrid = filterApplyPosted;
      this.enableClearSortPostedGrid = !this.gridPostedWithoutDeposit.api.getSortModel().length;
      if (!filterApplyPosted) {
        this.sumTotalDepositOrPostedSelected(gridName);
      } else {
        this.totalPostedAmountSelected = this.totalPostedAmount;
      }
    }
  }

  sumTotalDepositOrPostedSelected(gridName: string): void {
    if (DepositGridName.DepositGrid === gridName) {
      let total = 0;
      this.gridDepositOptions.api.forEachNodeAfterFilterAndSort((node) => {
        if (node && node.data && node.data.credit) {
          total += node.data.credit;
        }
      });
      this.totalDepositAmountSelected = total;
    } else if (DepositGridName.PostedGridRight === gridName) {
      let totalPosted = 0;
      this.gridPostedWithoutDeposit.api.forEachNodeAfterFilterAndSort((node) => {
        if (node && node.data && node.data.amount) {
          totalPosted += node.data.amount;
        }
      });
      this.totalPostedAmountSelected = totalPosted;
    }
  }

  getCurrentIndex(depositRowId?: number): number {
    const filteredData: any[] = this.getDepositFilteredAndSort();
    const rowSelectedId = depositRowId ? Number(depositRowId) : Number(this.selectedRowIndex);
    return filteredData.findIndex((depositRow: any) => depositRow.id === rowSelectedId);
  }

  getDepositFilteredAndSort(): any[] {
    this.filteredDataAndSort = [];
    if (this.gridDepositOptions && this.gridDepositOptions.api) {
      this.gridDepositOptions.api.forEachNodeAfterFilterAndSort(node => this.filteredDataAndSort.push(node.data));
    }
    return this.filteredDataAndSort;
  }

  deselectAll(gridName: string): void {
    switch (gridName) {
      case DepositGridName.DepositGrid:
        if (this.gridDepositOptions && this.gridDepositOptions.api) {
          this.gridDepositOptions.api.deselectAll();
        }
        break;
      case DepositGridName.PostedGridRight:
        if (this.gridPostedWithoutDeposit && this.gridPostedWithoutDeposit.api) {
          this.gridPostedWithoutDeposit.api.deselectAll();
          this.postedItemSelected = [];
        }
        break;
    }
  }

  getIncludeZeroBalance(): void {
    this.selectedRowIndex = null;
    const dateMonthLockBox = this.depositMonthConciliationCtrl.value;
    if (dateMonthLockBox) {
      const idSearch = this.idConciliationCtrl.value;
      const id = !isNaN(idSearch) ? Number(idSearch) : null;
      const statusIds = this.statusSelectedList.map(row => row.id);
      const description = this.descriptionConciliationCtrl.value;
      const descVal = description ? description.trim() : null;
      const request: IDeposit = {
        id: id,
        depositstatusids: statusIds.length ? statusIds : [],
        description: descVal,
        depositdate: this.getDepositDateSetterRequest(),
        includeZeroBalance: this.zeroBalanceCheckBox
      };
      this.getPostedWithoutDeposit(request);
    }
  }

  deleteRow(event: any, gridName: string): void {
    switch (gridName) {
      case DepositGridName.DepositGrid:
        if (this.actionsConciliation.includes(DepositActions.DepositDelete)) {
          if (event && event.colDef && event.colDef.colId === 'action') {
            if (event.data && event.data.id) {
              this.t2LoadingService.show();
              this.subscriptions.push(
                this.objServ.deleteDeposit(event.data.id)
                .finally(() => this.t2LoadingService.hiden())
                .subscribe({
                  next: (res) => {
                    if (res && res.message) {
                      this.gridDepositOptions.api.removeItems([event.node]);
                      this.objToast.success(res.message, 'Success!', { positionClass: 'toast-bottom-right' });
                    }
                  },
                  error: (err) => this.sweetAlertHelper.captureException(err)
                })
              );
            }
          }
        } else {
          this.objToast.error('You do not have permission to perform this action', 'Access Denied!',
            { positionClass: 'toast-bottom-right' });
        }
        break;
      case DepositGridName.PostedGridRight:
        if (this.actionsConciliation.includes(DepositActions.PostedDelete)) {
          if (event && event.colDef && event.colDef.colId === 'action') {
            if (event.data && event.data.id) {
              this.t2LoadingService.show();
              this.subscriptions.push(
                this.objServ.deletePosted(event.data.id)
                .finally(() => this.t2LoadingService.hiden())
                .subscribe({
                  next: (res) => {
                    if (res && res.message) {
                      this.gridPostedWithoutDeposit.api.removeItems([event.node]);
                      this.objToast.success(res.message, 'Success!', { positionClass: 'toast-bottom-right' });
                    }
                  },
                  error: (err) => this.sweetAlertHelper.captureException(err)
                })
              );
            }
          }
        } else {
          this.objToast.error('You do not have permission to perform this action', 'Access Denied!',
            { positionClass: 'toast-bottom-right' });
        }
        break;
    }
  }

  getCtrlByName(controlName: string): AbstractControl {
    return this.postedCrudForm.get(controlName);
  }

  clearControlCrud(controlName: string, value = ''): void {
    this.postedCrudForm.get(controlName).patchValue(value);
  }

  saveChanges(): void {
    if (this.validControls) {
      this.t2LoadingService.show();
      const formData = this.postedCrudForm.getRawValue();
      formData.payor = formData.payor ? formData.payor.trim() : null;
      formData.checknumber = formData.checknumber ? formData.checknumber.trim() : null;
      formData.rcsql = formData.rcsql ? formData.rcsql.trim() : null;
      formData.company = formData.company ? formData.company.trim() : null;
      formData.depositid = formData.depositid && !isNaN(Number(formData.depositid)) ? Number(formData.depositid) : null;
      formData.amtpaid = formData.amtpaid && !isNaN(Number(formData.amtpaid)) ? Number(formData.amtpaid) : null;
      const req: IPosted = Object.assign({}, formData);

      this.subscriptions.push(
        this.objServ.updatePosted(req)
        .finally(() => this.t2LoadingService.hiden())
        .subscribe({
          next: (resp) => {
            if (resp && resp.message) {
              this.objToast.success(resp.message, 'Success!', { positionClass: 'toast-bottom-right' });
              if (resp && resp.data) {
                this.setterData(resp.data);
                const rowModified = {
                  id: resp.data.id,
                  depositdate: resp.data.depositdate,
                  checkdate: resp.data.checkdate,
                  amount: resp.data.amtpaid,
                  checknbr: resp.data.checknumber,
                  payor: resp.data.payor,
                  rcsql: resp.data.rcsql,
                  posteddate: resp.data.posteddate,
                  company: resp.data.company
                };
                this.updateGridCell(rowModified);
              }

              this.modalPosted.close();
            }
          },
          error: (er) => this.sweetAlertHelper.captureException(er)
        })
      );
    } else {
      this.objToast.error('Action not allowed', '', { positionClass: 'toast-bottom-right' });
    }
  }

  updateGridCell(data: any) {
    const rowNode = this.gridPostedWithoutDeposit.api.getRowNode(data.id);
    rowNode.setData(data);
  }

  setterData(params: any): void {
    if (params && params.id) {
      const formatDate = 'yyyy-MM-dd';
      const postedDate = CustomDate.formatJs(params.posteddate, formatDate);
      const checkDate = CustomDate.formatJs(params.checkdate, formatDate);
      const depositDate = CustomDate.formatJs(params.depositdate, formatDate);
      const amountVal = params.amtpaid ? params.amtpaid : params.amount;
      const checkNumberVal = params.checknbr ? params.checknbr : params.checknumber;

      this.getCtrlByName('id').patchValue(params.id);
      this.getCtrlByName('payor').patchValue(params.payor);
      this.getCtrlByName('amtpaid').patchValue(amountVal);
      this.getCtrlByName('posteddate').patchValue(postedDate);
      this.getCtrlByName('checkdate').patchValue(checkDate);
      this.getCtrlByName('checknumber').patchValue(checkNumberVal);
      this.getCtrlByName('depositdate').patchValue(depositDate);
      this.getCtrlByName('rcsql').patchValue(params.rcsql);
      this.getCtrlByName('company').patchValue(params.company);
      this.getCtrlByName('depositid').patchValue(params.depositid);
    }
  }

  closeModal(): void {
    this.modalPosted.close();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) =>
      subscription.unsubscribe()
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/billing-general/deposits/conciliation/conciliation.component.ts